import { Navigation } from '@ffw/randstad-shared-components/build';
import UI from '@UI/hoc/UI';

export default UI(Navigation)({ theme: 'sph' });
